import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _questionActionsMap;

import { EQuestionActionsTypes } from '../../../constants';
import { SubmitActionContainer } from '../containers/SubmitActionContainer';
import { SecondarySubmitActionContainer } from '../containers/SecondarySubmitActionContainer';
export var questionActionsMap = (_questionActionsMap = {}, _defineProperty(_questionActionsMap, EQuestionActionsTypes.NextQ, SubmitActionContainer), _defineProperty(_questionActionsMap, EQuestionActionsTypes.Skip, SecondarySubmitActionContainer), _questionActionsMap);